const { origin, hostname } = window.location;

let server = {
    host: "qaapi.tiendamaslogistica.ddrcloud.com.ar"
};

let http = origin.indexOf("https") !== -1 ? "https://" : "http://";

switch (hostname) {
    case "tienda.maslogistica.com.ar":
        server.host = "api.tiendamaslogistica.ddrcloud.com.ar";
        break;  
    case "pp-tienda.maslogistica.com.ar":
        server.host = "preproapi.tiendamaslogistica.ddrcloud.com.ar";
        break;
    default:
    break;
}

console.log(http + server.host);

const url = http + server.host;

module.exports = [url];
